import { Link } from "react-router-dom";
import { FaApple, FaGooglePlay, FaInstagram, FaXTwitter, FaFacebookF, FaLinkedinIn } from "react-icons/fa6";

const LOGO = "https://customer-assets.emergentagent.com/job_9c6a7b9b-6c36-4fd3-a6ee-0e90154b575f/artifacts/5l6igzsb_IMG_9847.PNG";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink-900 text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO} alt="FUDK" className="h-12 w-12 rounded-md ring-1 ring-white/10" />
              <div>
                <div className="font-display font-black text-2xl">FUDK</div>
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#A3E635]">Your food delivery app</div>
              </div>
            </div>
            <p className="mt-6 text-sm text-white/65 max-w-sm leading-relaxed">
              Built with love in Berhampur, Odisha . FUDK connects you to the kitchens you love — fast, fresh, fair.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a href="#" data-testid="footer-appstore-btn" className="flex items-center gap-2 bg-black border border-white/10 hover:border-[#84CC16] px-4 py-2.5 rounded-xl">
                <FaApple size={20} />
                <span className="text-xs font-semibold">App Store</span>
              </a>
              <a href="#" data-testid="footer-playstore-btn" className="flex items-center gap-2 bg-black border border-white/10 hover:border-[#84CC16] px-4 py-2.5 rounded-xl">
                <FaGooglePlay size={18} className="text-[#84CC16]" />
                <span className="text-xs font-semibold">Google Play</span>
              </a>
            </div>
          </div>

          <div className="col-span-1 md:col-span-2">
            <div className="text-xs uppercase tracking-[0.25em] text-white/50 font-bold mb-4">Explore</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-[#A3E635]" data-testid="footer-link-home">Home</Link></li>
              <li><a href="/#about" className="hover:text-[#A3E635]" data-testid="footer-link-about">About</a></li>
              <li><Link to="/restaurants" className="hover:text-[#A3E635]" data-testid="footer-link-restaurants">Restaurants</Link></li>
              <li><Link to="/analytics" className="hover:text-[#A3E635]" data-testid="footer-link-analytics">Analytics</Link></li>
              <li><a href="/#contact" className="hover:text-[#A3E635]" data-testid="footer-link-contact">Contact</a></li>
            </ul>
          </div>
          <div className="col-span-1 md:col-span-2">
            <div className="text-xs uppercase tracking-[0.25em] text-white/50 font-bold mb-4">Company</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-[#A3E635]">Careers</a></li>
              <li><a href="#" className="hover:text-[#A3E635]">Press</a></li>
              <li><a href="#" className="hover:text-[#A3E635]">Partners</a></li>
              <li><a href="#" className="hover:text-[#A3E635]">For Restaurants</a></li>
            </ul>
          </div>
          <div className="col-span-2 md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-white/50 font-bold mb-4">Get in touch</div>
            <ul className="space-y-2 text-sm text-white/80">
              <li><a href="mailto:contactus@foodk.in" className="hover:text-[#A3E635]" data-testid="footer-email">contactus@foodk.in</a></li>
              <li><a href="tel:+918926004409" className="hover:text-[#A3E635]" data-testid="footer-phone">+91 8926004409</a></li>
              <li className="text-white/65 leading-relaxed">Khata No. 518/133, Plot No. 1095/1366, Bijipur Main Road, Bijipur, Berhampur, Ganjam, Odisha - 760004, India</li>
            </ul>
            <div className="mt-5 flex items-center gap-3 text-white/70">
              <a href="#" aria-label="Instagram" className="hover:text-[#A3E635]"><FaInstagram size={18} /></a>
              <a href="#" aria-label="Twitter" className="hover:text-[#A3E635]"><FaXTwitter size={18} /></a>
              <a href="#" aria-label="Facebook" className="hover:text-[#A3E635]"><FaFacebookF size={16} /></a>
              <a href="#" aria-label="LinkedIn" className="hover:text-[#A3E635]"><FaLinkedinIn size={16} /></a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/55">
          <div>© {new Date().getFullYear()} FUDK. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Cookies</a>
          </div>
        </div>

        {/* Massive type */}
        <div aria-hidden className="mt-10 select-none pointer-events-none">
          <div className="font-display font-black tracking-tighter text-[24vw] leading-[0.85] text-white/[0.04]">FUDK</div>
        </div>
      </div>
    </footer>
  );
}
